var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "restructureEditor" },
    [
      _c("el-upload", {
        class: _vm.myRef + "upload",
        staticStyle: { height: "0px", display: "none" },
        attrs: {
          action: _vm.serverUrl,
          name: "file",
          headers: _vm.headers,
          "show-file-list": false,
          "list-type": "picture",
          accept: ".jpg,.png,.jpeg",
          "with-credentials": "",
          multiple: true,
          "on-success": _vm.uploadSuccess,
          "on-error": _vm.uploadError
        }
      }),
      _vm._v(" "),
      _c("quill-editor", {
        ref: _vm.myRef,
        staticClass: "ql-editor",
        class: { jyxClass: _vm.jyxStyle },
        attrs: { options: _vm.editorOption },
        on: {
          blur: function($event) {
            return _vm.onEditorBlur($event)
          },
          focus: function($event) {
            return _vm.onEditorFocus($event)
          }
        },
        model: {
          value: _vm.content,
          callback: function($$v) {
            _vm.content = $$v
          },
          expression: "content"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-311a95ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311a95ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zl-editor/index.vue
// module id = null
// module chunks = 